import _ from 'lodash';
import moment from 'moment';
import Vue from 'vue';
import { HTTP, SEARCH } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultArticle = {
  tag_ids: [],
};

export default {
  actions: {
    async [actions.DO_CREATE_ARTICLE]({ commit }, payload) {
      const { data } = await HTTP.post('/articles', payload);
      commit(mutations.SET_ARTICLE, data.data.articles[0]);
      return data;
    },
    async [actions.DO_DELETE_ARTICLE]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.delete(`/articles/${id}`, params);
      commit(mutations.SET_ARTICLE, data.data.articles[0]);
      return data;
    },
    async [actions.DO_GET_ARTICLE]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/articles/${id}`, { params });
      commit(mutations.SET_ARTICLE, data.data.articles[0]);
      return data;
    },
    async [actions.DO_SEARCH_ARTICLES]({ commit }, payload) {
      const { data } = await SEARCH.post('/doxa_articles/article/_search', payload);
      const articles = data.hits.hits.map(h => h._source);
      commit(mutations.SET_ARTICLES, articles);
      return data;
    },
    async [actions.DO_UPDATE_ARTICLE]({ commit }, payload) {
      const { id, ignore, ...params } = payload;
      const { data } = await HTTP.patch(`/articles/${id}`, params);
      if (!ignore) commit(mutations.SET_ARTICLE, data.data.articles[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_ARTICLE]: state => state.article,
    [getters.GET_ARTICLE_EDITING]: state => state.editing,
    [getters.GET_ARTICLES]: state => state.articles,
  },
  mutations: {
    [mutations.SET_ARTICLE](state, article) {
      if (article.pub_date) {
        article.pub_date = moment(article.pub_date).toDate();
      }
      state.article = article;
    },
    [mutations.SET_ARTICLE_EDITING_TAG_AT_INDEX](state, field) {
      Vue.set(state.editing.tag_ids, field.index, field.val);
    },
    [mutations.SET_ARTICLE_EDITING](state, editing) {
      state.editing = editing;
    },
    [mutations.SET_ARTICLE_EDITING_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.editing;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_ARTICLE_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.article;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_ARTICLES](state, articles) {
      state.articles = articles;
    },
    [mutations.UNSET_ARTICLE](state) {
      state.article = _.cloneDeep(defaultArticle);
    },
  },
  state: {
    article: _.cloneDeep(defaultArticle),
    articles: [],
    editing: _.cloneDeep(defaultArticle),
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/article.js